package com.daytimegaming.ourdailyfinances.presentation.dashboard

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material3.Card
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.daytimegaming.ourdailyfinances.domain.model.Account
import com.daytimegaming.ourdailyfinances.domain.model.DashboardAccount
import com.daytimegaming.ourdailyfinances.domain.model.RealEstateHolding
import com.daytimegaming.ourdailyfinances.presentation.util.formatAmount
import com.daytimegaming.ourdailyfinances.presentation.util.toCurrencySymbol

fun DashboardAccount.toAccount() = Account(
    accountId = accountId,
    name = name,
    officialName = officialName,
    type = type,
    subtype = subtype,
    currentBalance = currentBalance,
    availableBalance = availableBalance,
    isoCurrencyCode = isoCurrencyCode,
    institutionName = institutionName,
    itemId = itemId,
    nickname = nickname
)

@Composable
fun SelectedAccountItem(
    account: Account,
    onRemove: () -> Unit,
    showDeleteButton: Boolean = true
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
    ) {
        Row(
            modifier = Modifier.padding(16.dp),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Column(modifier = Modifier.weight(1f)) {
                Text(text = account.displayName, style = MaterialTheme.typography.titleSmall)
                val subtitle = listOfNotNull(
                    account.subtype?.uppercase(),
                    account.institutionName
                ).joinToString(" • ")
                if (subtitle.isNotEmpty()) {
                    Text(
                        text = subtitle,
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                }
            }
            Spacer(Modifier.width(8.dp))
            account.currentBalance?.let { balance ->
                Text(
                    text = "${account.isoCurrencyCode.toCurrencySymbol()}${balance.formatAmount()}",
                    style = MaterialTheme.typography.bodyMedium,
                )
            }
            if (showDeleteButton) {
                Spacer(Modifier.width(16.dp))
                IconButton(onClick = onRemove) {
                    Icon(
                        imageVector = Icons.Default.Delete,
                        contentDescription = "Remove Account",
                        tint = MaterialTheme.colorScheme.error
                    )
                }
            }
        }
    }
}

@Composable
fun SelectedRealEstateItem(
    holding: RealEstateHolding,
    onRemove: () -> Unit,
    showDeleteButton: Boolean = true
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
    ) {
        Row(
            modifier = Modifier.padding(16.dp),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Column(modifier = Modifier.weight(1f)) {
                Text(text = holding.nickname, style = MaterialTheme.typography.titleSmall)
                val addressText = buildString {
                    append(holding.addressLine1)
                    holding.addressLine2?.let {
                        if (it.isNotEmpty()) append(", ").append(it)
                    }
                    append(", ").append(holding.city).append(", ").append(holding.state).append(" ").append(holding.zipCode)
                }
                Text(
                    text = addressText,
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            }
            Spacer(Modifier.width(8.dp))
            Text(
                text = "$${holding.purchasePrice.formatAmount()}",
                style = MaterialTheme.typography.bodyMedium,
            )
            if (showDeleteButton) {
                Spacer(Modifier.width(16.dp))
                IconButton(onClick = onRemove) {
                    Icon(
                        imageVector = Icons.Default.Delete,
                        contentDescription = "Remove Real Estate",
                        tint = MaterialTheme.colorScheme.error
                    )
                }
            }
        }
    }
}
